export default function manageSubscription(app)
{

    /**
     * Update the proxies list based on the service id
     *
     * @param serviceId
     */

    const updateProxiesList = (serviceId) => {

        // Get the proxies element
        const $proxies = $('#assigned_proxies')

        // For storing the formatted proxies
        const rows = []

        // For each proxy
        window.proxiesList.forEach(proxy => {

            // Store the proxy
            let row = (typeof proxy === 'object' ? proxy.ip : proxy) + ':' + window.serviceCredentials.port

            // Add the username and the password if user authentication
            if(serviceId === 'user') row += ':' + window.serviceCredentials.username + ':' + window.serviceCredentials.password

            // Store the row
            rows.push(row)

        })

        // Set the proxies
        $proxies.val(rows.join("\n"))

    }

    /**
     * Handle the Proxy Auth Type change
     *
     * @param args
     */

    const onProxyAuthTypeChange = (args) => {

        // Get the service id
        const serviceId = args.value

        // Get the IPs textarea
        const $ips = $('#authorized')

        $ips
            // Update the placeholder
            .attr('placeholder', window.servicesInfo[serviceId]['placeholder'])
            // Enable or disable the textarea
            .attr('disabled', window.servicesInfo[serviceId]['disabled'])
            // Toggle the disabled class
            .parents('.form-field-inner').toggleClass('disabled')

        updateProxiesList(serviceId)

    }

    $(function(){

        // If we need to open the manage overlay
        if(window.location.hash === '#manage') {

            // Get the button
            const $button = $('#manage-subscription')

            // If we have a button and not disabled
            if($button.length > 0 && !$button.is(':disabled')) {

                // CLick the button
                $button.click()

            }

        }

        // Handle the proxy change
        app.events.on('kx_dropdownSelect:auth_proxy_type', onProxyAuthTypeChange)

    })

}
